<template>
  <div>
    <plan-list v-if="$route.name === 'plan-list'"></plan-list>
    <router-view v-else></router-view>
  </div>
</template>

<script lang="ts">
import PlanList from './PlanList.vue'

export default {
  name: 'PlanIndex',
  components: { PlanList },
}
</script>

<style scoped lang="scss"></style>
